import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import { LocaleCode } from '@/entities/account';
import { useAccountStore } from '@/shared/stores/accountStore';

import { useUpdateAccountSettings } from './useUpdateAccountSettings';

export function useChangeLanguage(isAuthPage?: boolean) {
  const { i18n } = useTranslation();
  const setLocaleStore = useAccountStore((set) => set.setLocale);
  const { updateAccountSettings, ...other } = useUpdateAccountSettings();
  const queryClient = useQueryClient();

  const changeLanguage = async (locale: LocaleCode) => {
    await i18n.changeLanguage(locale);
    setLocaleStore(locale);
    await queryClient.invalidateQueries(); // Для исключения рассинхрона локали с бэкендом
    if (!isAuthPage) {
      await updateAccountSettings({ locale });
    }
  };

  return { changeLanguage, ...other };
}
